<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="uniToolTipTranslation('S430', 'en-US')"
        class="card-panel"
        style="height:100%; margin-bottom: 0px !important"
      >
        <RefrigerantPicker :path="path"></RefrigerantPicker>

        <UnidataEditor :parent-path="path" :name="'.flow'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.saturationTemperature'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.saturationPressure'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.inletGasTemperature'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.subcooling'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.pressureDrop'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.foulingFactor'"></UnidataEditor>

        <UnidataEditorCorrelator :parent-path="path" group="FluidVelocity">
        </UnidataEditorCorrelator>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import RefrigerantPicker from "../shared/RefrigerantPicker";
import UnidataEditor from "../unidata/UnidataEditor";
import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
// import UnidataEditorCorrelatorOptionList from "../unidata/UnidataEditorCorrelatorOptionList";
import { mapGetters } from "vuex";
// import { Radio, Collapse, CollapseItem } from "element-ui";
// import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    RefrigerantPicker,
    UnidataEditor,
    UnidataEditorCorrelator /*,
    UnidataEditorCorrelatorOptionList,
    "el-radio": Radio,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
  },
  methods: {
    /*...mapActions([
        'increment'
      ])*/
  }
};
</script>

<style lang="scss"></style>

<!--
<style lang="scss">

div{
  hr{
    margin-bottom: 10px;
    margin-top: 0;
  }
  .radio-unidata{
    display:flex;
    flex-direction: row;
    .radio-container{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-top: 25px;
      padding-left: 10px;
      width:160px;
      label{
        margin-bottom: 0px;
      }
      .el-radio + .el-radio{
        margin-left: 0px
      }
    }
  }
}


</style>
-->
